//Import Libraries
import React, { useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Button from "@material-ui/core/Button";
import { updateAlert, updateSourceInputs } from "../../../../redux/actions";
import EditableTable from "./EditableTable";
import fieldsArr from "../../fields";
import "../../rociview.scss";
import { config } from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MetaSearchFilter from "./MetaSearchFilter";
import { useUserAuthentication } from "../../../../utils/utils";
import { useHistory } from "react-router-dom";
import { ApprovalTable } from "../../../../components/Approval/ApprovalTable";
import DynamicDialog from "../../../../components/Dialog/Dialog";

let api = config.api.api_url;

function PillerPowerBrandView(props) {
  const {
    user,
    match,
    updateSourceInputs,
    updateAlert,
    source_data,
    getSources,
    clearReduxState,
    loading,
    setLoading,
    isApproval,
    getApprovalData,
  } = props;

  // STATES
  const [isTableDataSaving, setIsTableDataSaving] = useState(false);
  const [isSearchFilterLoading, setIsSearchFilterLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isEdit, setIsEdit] = useState(false);
  const [globalEdit, setGlobalEdit] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [isPlaceholderFetching, setIsPlaceholderFetching] = useState(false);
  const [isDynamicDialogOpen, setIsDynamicDialogOpen] = useState(false);
  const [dynamicDialogMessage, setDynamicDialogMessage] = useState();
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [currentEditingRowData, setCurrentEditingRowData] = useState(null);

  let history = useHistory();
  const URL = history?.location?.pathname;
  const Use_Case_Name = URL.split("/").pop();
  const { login } = useUserAuthentication();

  // FUNCTIONS

  const getData = (row) => {};

  const outlinedCNCButton = {
    borderColor: "#46596A",
    // background-color: #d7dadd,
    color: "#46596A",
    // width: '100%',
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const containedButton = {
    color: "white",
    backgroundColor: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    // marginLeft: "10px !important",
    marginRight: "5px",
  };

  const IS_ANY_ROWDATA_NULL = useMemo(() => {
    if (
      source_data.current_mapped_data &&
      source_data.current_mapped_data.length > 0 &&
      source_data.data.dropdown
    ) {
      const ExceptionKeys = [
        ...(source_data?.data?.dropdown?.metadata_filter || []),
      ];

      return source_data?.current_mapped_data.some((singleRowData) => {
        return Object.keys(singleRowData.rowData).every(
          (key) =>
            ExceptionKeys.includes(key) || singleRowData.rowData[key] === null,
        );
      });
    } else {
      return false;
    }
  }, [
    source_data.current_mapped_data,
    source_data.current_ssfFileId,
    source_data.current_filter_value,
  ]);

  const IS_ANY_RECORDS_EDITED = useMemo(() => {
    if (source_data?.current_filter_value === "Create new") return true;
    if (source_data.isAnyRecordDeleted) return true;
    return (
      source_data?.current_mapped_data?.some(
        (item) => item.isEdited === true,
      ) ?? false
    );
  }, [source_data.current_mapped_data, source_data.isAnyRecordDeleted]);

  //function to set page for changing table row
  const pageChange = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let page_props = {
    total: source_data.current_mapped_data
      ? Math.ceil(source_data.current_mapped_data.length / rowsPerPage)
      : 0,
    page: page,
    changePage: pageChange,
    rowsPerPage: rowsPerPage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    show_pageOptions: true,
  };

  function cancelFunction() {
    setIsCancelDialogOpen(false);
    // updateSourceInputs("data",[]);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("is_initial", true);
    getSources();
  }

  function mergeWithObj2Priority(obj1, obj2) {
    const commonKeys = Object.keys(obj1).filter((key) => key in obj2);

    if (commonKeys.length > 0) {
      // Merge and overwrite obj1 values with obj2 values for common keys
      return {
        ...obj1,
        ...obj2, // obj2 values take priority
      };
    } else {
      // No common keys – just merge all keys
      return {
        ...obj1,
        ...obj2,
      };
    }
  }

  const getSortedModifiedData = () => {
    const Temp_Modidified_Data = source_data.modified_mapped_data.map(
      (item) => {
        const Is_Single_Insert = Object?.keys(item.updated)?.some((key) => {
          const is_single_insert_applicable_column =
            source_data?.data?.dropdown?.is_single_insert_applicable_columns?.includes(
              key,
            );
          if (!is_single_insert_applicable_column) return false;
          return source_data?.data?.dropdown?.is_single_insert_applicable_values?.includes(
            item?.updated?.[key],
          );
        });
        if (source_data.current_source.value.toLowerCase() === "nielsen") {
          return {
            ...item,
            isEdited: item.isEdited,
            isNew: item.isNew,
            updated: {
              ...item.updated,
              COUNTRY_CODE: source_data.current_country_code,
              CREATED_AT: item?.updated?.CREATED_AT || null,
              CREATED_BY: item.isNew
                ? user.mail || null
                : item.updated.CREATED_BY || null,
              UPDATED_AT: item?.updated?.UPDATED_AT || null,
              UPDATED_BY: !item.isNew
                ? user.mail || null
                : item.updated.UPDATED_BY || null,
              ISNEW: item?.updated?.ISNEW
                ? item.updated.ISNEW
                : item?.isNew || false,
              ISDELETED: item?.updated?.ISDELETED
                ? item.updated.ISDELETED
                : item?.isDeleted || false,
              ISEDITED: item?.updated?.ISEDITED
                ? item.updated.ISEDITED
                : item?.isEdited || false,
              IS_SINGLE_INSERT: Is_Single_Insert || false,
            },
          };
        } else {
          return {
            ...item,
            isEdited: item.isEdited,
            isNew: item.isNew,
            updated: {
              ...item.updated,
              CREATED_AT: item?.updated?.CREATED_AT || null,
              CREATED_BY: item.isNew
                ? user.mail || null
                : item.updated.CREATED_BY || null,
              UPDATED_AT: item?.updated?.UPDATED_AT || null,
              UPDATED_BY: !item.isNew
                ? user.mail || null
                : item.updated.UPDATED_BY || null,
              ISNEW: item?.updated?.ISNEW
                ? item.updated.ISNEW
                : item?.isNew || false,
              ISDELETED: item?.updated?.ISDELETED
                ? item.updated.ISDELETED
                : item?.isDeleted || false,
              ISEDITED: item?.updated?.ISEDITED
                ? item.updated.ISEDITED
                : item?.isEdited || false,
              IS_SINGLE_INSERT: Is_Single_Insert || false,
            },
          };
        }
      },
    );

    // Merge the Actual and updated object of modified data
    const Temp_modified_data_map = source_data.modified_mapped_data.map(
      (item) => {
        return mergeWithObj2Priority(item.actual, item.updated);
      },
    );

    const Current_Mapped_Data_With_Country_Code =
      source_data.current_mapped_data.map((item) => {
        const Is_Single_Insert = Object?.keys(item.rowData)?.some((key) => {
          const is_single_insert_applicable_column =
            source_data?.data?.dropdown?.is_single_insert_applicable_columns?.includes(
              key,
            );
          if (!is_single_insert_applicable_column) return false;
          return source_data?.data?.dropdown?.is_single_insert_applicable_values?.includes(
            item?.rowData?.[key],
          );
        });
        return {
          ...item,
          rowData: {
            ...item.rowData,
            CREATED_AT: item?.rowData?.CREATED_AT || null,
            CREATED_BY: item.isNewData
              ? user.mail || null
              : item.rowData.CREATED_BY || null,
            UPDATED_AT: item?.rowData?.UPDATED_AT || null,
            UPDATED_BY: !item.isNewData
              ? user.mail || null
              : item.rowData.UPDATED_BY || null,
            ISNEW: item?.rowData?.ISNEW || false,
            ISDELETED: item?.rowData?.ISDELETED || false,
            ISEDITED: item?.rowData?.ISEDITED || false,
            IS_SINGLE_INSERT: Is_Single_Insert || false,
          },
        };
      });

    // Remove the data which is modified from the current mapped data
    const Changed_Rows_Removed_Data =
      Current_Mapped_Data_With_Country_Code.filter((item) => {
        const isDuplicate = Temp_modified_data_map.some((data) =>
          source_data.data.dropdown.duplicate_validation_attributes.every(
            (attribute) => item.rowData[attribute] === data[attribute],
          ),
        );

        // Keep only if it's NOT a duplicate
        return !isDuplicate;
      });

    // Structure the Changed_Rows_Removed_Data
    const Temp_UnChanged_Data_Two = Changed_Rows_Removed_Data.map((item) => {
      return {
        actual: item.rowData,
        updated: {
          ...item.rowData,
          UPDATED_BY: user?.mail || null,
        },
        isEdited: false,
        isNew: false,
        isDeleted: false,
      };
    });

    const MODIFIED_MAPPED_DATA = [
      ...Temp_Modidified_Data,
      ...Temp_UnChanged_Data_Two,
    ];

    // Sorting MODIFIED_MAPPED_DATA by making null as String (i., "null")
    const SORTED_MODIFIED_MAPPED_DATA = MODIFIED_MAPPED_DATA.map((item) => {
      return {
        ...item,
        actual: item.isNew ? {} : item.actual,
        updated: {
          ...item.updated,
          USERID: user?.mail || null,
        },
      };
    });

    return SORTED_MODIFIED_MAPPED_DATA;
  };

  // Function with Mock Data for Calculated Expression validation Flow
  const onSave = async () => {
    setIsTableDataSaving(true);

    // Getting The MODIFIED_MAPPED_DATA with IS_EDITED ATTRIBUTE
    const MODIFIED_MAPPED_DATA = getSortedModifiedData();
    const FINAL_MODIFIED_MAPPED_DATA = MODIFIED_MAPPED_DATA.map((item) => {
      return {
        ...item,
        updated: {
          ...item.updated,
          EXISTING_POWER_BRAND: item?.actual?.POWER_BRAND || "",
        },
      };
    });

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        business_unit: source_data?.current_bussines_unit?.value || "",
        country_code: source_data?.current_country_code || "",
        userid: user?.mail || "",
        source: source_data?.current_source?.value || "",
      });

      const response = await fetch(
        api + `/local_reporting/pillar_brand/add_awaiting_data?${params}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(FINAL_MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      updateAlert({
        open: true,
        message: "Validating the records",
        severity: "success",
        closeFlag: true,
      });
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login();
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      // Check response for successful DB update
      if (data.statusCode === "harbor-200") {
        clearReduxState();
        getSources();

        // Toast OnSuccess
        updateAlert({
          open: true,
          message: "All the changes are saved & awaiting for approval",
          severity: "success",
          closeFlag: true,
        });
      } else {
        // RESPONSE DATA FROM BACKEND API
        const Response = data.validated_result;

        // STEP 1 = UPDATE CURRENT_MAPPED_DATA RECORDS WITH RESPECTIVE RECORD FROM ACTUAL_UPDATED_COMBINED_DATA
        const Sorted_Mapped_Data = source_data.current_mapped_data.map(
          (item) => {
            // COMPARE MAPPED_DATA WITH RESPONSE DATA AND UPDATE ITS IS_VALIDATED ATTRIBUTE
            const matchedData = Response.find((data) => {
              const Merged_Data =
                source_data.current_filter_value === "Existing"
                  ? mergeWithObj2Priority(data.actual, data.updated)
                  : data.updated;
              // Check if all duplicate validation attributes match
              return source_data.data.dropdown.duplicate_validation_attributes.every(
                (attribute) => {
                  return item.rowData[attribute] === Merged_Data[attribute];
                },
              );
            });

            return {
              ...item,
              isEdited: matchedData
                ? matchedData.isEdited === "true"
                  ? true
                  : false
                : item.isEdited,
              isValidated: matchedData
                ? matchedData.isValidation === "true"
                  ? true
                  : false
                : item.isValidated,
              errorMessage:
                matchedData.isValidation === "false"
                  ? matchedData.exception_details
                  : "",
            };
          },
        );

        // STEP 2 = SORTING THE Sorted_Mapped_Data By keeping the Items with isValidated = false at top
        const FINAL_SORTED_MAPPED_DATA = Sorted_Mapped_Data.sort((a, b) => {
          return a.isValidated - b.isValidated;
        });

        updateSourceInputs("current_mapped_data", FINAL_SORTED_MAPPED_DATA);
        updateSourceInputs("appliedFilters", []);
        updateSourceInputs("searchValue", "");
        updateSourceInputs("filtered_Rows", []);

        // Error Toast
        updateAlert({
          open: true,
          message: "There was an error in the expression validation",
          severity: "Failed ",
          closeFlag: true,
        });
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsTableDataSaving(false);
    setIsSaveDialogOpen(false);
  };

  const onSaveAwaitingData = async () => {
    setIsTableDataSaving(true);

    // Getting The MODIFIED_MAPPED_DATA with IS_EDITED ATTRIBUTE
    const MODIFIED_MAPPED_DATA = getSortedModifiedData();

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        business_unit: source_data?.current_bussines_unit?.value || "",
        country_code: source_data?.current_country_code || "",
        userid: user?.mail || "",
        source: source_data?.current_source?.value || "",
      });
      const response = await fetch(
        api + `/local_reporting/pillar_brand/update_awaiting_data?${params}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      updateAlert({
        open: true,
        message: "Validating the records",
        severity: "success",
        closeFlag: true,
      });
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      // Check response for successful DB update
      if (data.statusCode === "harbor-200") {
        clearReduxState();
        getSources();

        // Toast OnSuccess
        updateAlert({
          open: true,
          message: "All the changes are saved & awaiting for approval",
          severity: "success",
          closeFlag: true,
        });
      } else {
        // RESPONSE DATA FROM BACKEND API
        const Response = data.validated_result;

        // STEP 1 = UPDATE CURRENT_MAPPED_DATA RECORDS WITH RESPECTIVE RECORD FROM ACTUAL_UPDATED_COMBINED_DATA
        const Sorted_Mapped_Data = source_data.current_mapped_data.map(
          (item) => {
            // COMPARE MAPPED_DATA WITH RESPONSE DATA AND UPDATE ITS IS_VALIDATED ATTRIBUTE
            const matchedData = Response.find((data) => {
              const Merged_Data =
                source_data.current_filter_value === "Existing"
                  ? mergeWithObj2Priority(data.actual, data.updated)
                  : data.updated;
              // Check if all duplicate validation attributes match
              return source_data.data.dropdown.duplicate_validation_attributes.every(
                (attribute) => {
                  return item.rowData[attribute] === Merged_Data[attribute];
                },
              );
            });

            return {
              ...item,
              isEdited: matchedData
                ? matchedData.isEdited === "true"
                  ? true
                  : false
                : item.isEdited,
              isValidated: matchedData
                ? matchedData.isValidation === "true"
                  ? true
                  : false
                : item.isValidated,
              errorMessage:
                matchedData.isValidation === "false"
                  ? matchedData.exception_details
                  : "",
            };
          },
        );

        // STEP 2 = SORTING THE Sorted_Mapped_Data By keeping the Items with isValidated = false at top
        const FINAL_SORTED_MAPPED_DATA = Sorted_Mapped_Data.sort((a, b) => {
          return a.isValidated - b.isValidated;
        });

        updateSourceInputs("current_mapped_data", FINAL_SORTED_MAPPED_DATA);
        updateSourceInputs("appliedFilters", []);
        updateSourceInputs("searchValue", "");
        updateSourceInputs("filtered_Rows", []);

        // Error Toast
        updateAlert({
          open: true,
          message: "There was an error in the expression validation",
          severity: "Failed ",
          closeFlag: true,
        });
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsTableDataSaving(false);
    setIsSaveDialogOpen(false);
  };

  const setMappedData = async (country_code) => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", true);

    let filteredDatasetValue;
    let DownloadSampleData;
    let have_awaiting_records = {};

    const Meta_Filters = source_data.data?.dropdown?.metadata_filters || [];

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        business_unit: source_data?.current_bussines_unit?.value || "",
        country_code: country_code || "",
        userid: user.mail || "",
        flow_type:
          source_data?.current_filter_value === "Existing"
            ? "existing"
            : "create_new",
        type: "Initial",
        source: source_data?.current_source?.value || "",
      });

      const response = await fetch(
        api + `/local_reporting/pillar_brand/getfetchdata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (source_data?.data?.dropdown?.is_value_fetch) {
        const Matching_Prefix =
          source_data?.data?.dropdown?.source_alias_for_dropdown?.find(
            (pref) => pref.label === source_data?.current_source?.value,
          ) || {};
        const SORTED_DROPDOWN_NAME = `${
          Matching_Prefix?.name || source_data?.current_source?.value
        }_BRAND`;
        const UPDATED_DROPDOWN_DATA = {
          ...source_data.data,
          dropdown: {
            ...source_data.data.dropdown,
            ...data.metadata,
            POWER_BRAND: data?.metadata?.[SORTED_DROPDOWN_NAME] || [],
          },
        };
        updateSourceInputs("data", UPDATED_DROPDOWN_DATA);
      } else {
        const UPDATED_DROPDOWN_DATA = {
          ...source_data.data,
          dropdown: {
            ...source_data.data.dropdown,
          },
        };
        updateSourceInputs("data", UPDATED_DROPDOWN_DATA);
      }

      if (data && data.data) {
        const DATA = data.data[0];
        have_awaiting_records = {
          has_records: data.awaiting_data_present || false,
          has_access: data.statusCode === "harbor-201" ? true : false,
          editor: DATA?.username || "",
          approver: DATA?.approver || "",
        };
        updateSourceInputs("has_awaiting_data", have_awaiting_records);
        // filteredDatasetValue = TableDataPillerAndPowerBrand || [];
        filteredDatasetValue = data.data;
      }

      DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    const Partitioned_By_Value =
      source_data?.data?.dropdown?.partitioned_by_column_details?.find(
        (val) => {
          return val?.SOURCE === source_data?.current_source?.value;
        },
      );
    let val = filteredDatasetValue || [];
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isPowerBrandNew: false,
          3: false,
          isCheckedRow: false,
          errorMessage: "",
          rowData: {
            ...item,
            PARTITIONED_BY: Partitioned_By_Value?.PARTITIONED_BY || "",
          },
        };
        ITEM_ID++;
        return rowData;
      });

    const SAMPLE_DOWNLOAD_FILE =
      DownloadSampleData?.map((item) => {
        let rowData = item;
        Object.keys(rowData).forEach((key) => {
          if (
            rowData[key] === "null" ||
            rowData[key] === undefined ||
            rowData[key] === null
          ) {
            rowData[key] = null;
          }
        });
        const Altered_RowData = rowData;

        if (source_data.current_source.toLowerCase() === "nielsen") {
          rowData = {
            ...Altered_RowData,
            // COUNTRY: source_data.current_country,
            [Meta_Filters?.[0]]: source_data.current_country_code,
            // [Meta_Filters?.[1]]: file_id,
            [Meta_Filters[2]]: source_data.current_source,
          };
        } else {
          rowData = {
            ...Altered_RowData,
            [Meta_Filters?.[0]]: source_data.current_country,
            // [Meta_Filters?.[1]]: file_id,
            [Meta_Filters[2]]: source_data.current_source,
          };
        }
        return rowData;
      }) ?? [];

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", tableData);
    updateSourceInputs("current_mapped_data_main", tableData);
    updateSourceInputs("download_sample_file", SAMPLE_DOWNLOAD_FILE);

    if (have_awaiting_records.has_records) {
      setIsDynamicDialogOpen(true);
      setDynamicDialogMessage(
        have_awaiting_records.has_access
          ? "Your awaiting data available for this file_Id, Do you want to fetch ?"
          : `Awaiting data available for this SFF_File_Id. ${
              `${have_awaiting_records?.editor} ${
                have_awaiting_records?.editor.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.editor.length > 1 ? "editors" : "editor"
            } and ${
              `${have_awaiting_records?.approver} ${
                have_awaiting_records?.approver.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.approver.length > 1
                ? "approvers"
                : "approver"
            }. Kindly contact them for further assistance`,
      );
    } else {
      updateSourceInputs("is_table_loading", false);
    }
  };

  const fetchAwaitingRecords = async () => {
    setIsDynamicDialogOpen(false);

    let filteredDatasetValue;

    try {
      const params = new URLSearchParams({
        usecase_name: Use_Case_Name || "",
        business_unit: source_data?.current_bussines_unit?.value || "",
        country_code: source_data?.current_country_code || "",
        userid: user.mail || "",
        flow_type:
          source_data?.current_filter_value === "Existing"
            ? "existing"
            : "create_new",
        type: "Awaiting",
        source: source_data?.current_source?.value || "",
      });

      const response = await fetch(
        api + `/local_reporting/pillar_brand/getfetchdata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (data && data.data) {
        filteredDatasetValue = data.data;
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    const Partitioned_By_Value =
      source_data?.data?.dropdown?.partitioned_by_column_details?.find(
        (val) => {
          return val?.SOURCE === source_data?.current_source?.value;
        },
      );
    let val = filteredDatasetValue || [];
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          isPowerBrandNew: false,
          isRBFilteredBrandNew: false,
          errorMessage: "",
          rowData: {
            ...item,
            PARTITIONED_BY: Partitioned_By_Value?.PARTITIONED_BY || "",
          },
        };
        ITEM_ID++;
        return rowData;
      });

    updateSourceInputs("current_mapped_data", tableData);
    updateSourceInputs("current_mapped_data_main", tableData);

    updateSourceInputs("is_table_loading", false);
  };

  const handleCreateNewRow = () => {
    setIsSearchFilterLoading(true);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    let filteredDatasetValue;
    let tableData;

    const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const CURRENT_MAPPED_DATA = source_data.current_mapped_data;
    let NewRowData = source_data.data.dropdown.insert_column_attributes;
    const Country =
      source_data.data.dropdown.COUNTRY?.find(
        (item) => item.country_code === source_data.current_country_code,
      ) || {};
    const CURRENT_MMAPING_TYPE =
      source_data?.data?.dropdown?.MAPPING_TYPE?.[
        source_data?.current_source?.value
      ] || null;
    const Partitioned_By_Value =
      source_data?.data?.dropdown?.partitioned_by_column_details?.find(
        (val) => {
          return val?.SOURCE === source_data?.current_source?.value;
        },
      );
    NewRowData = {
      ...NewRowData,
      SOURCE: source_data?.current_source?.value || "",
      COUNTRY: Country?.COUNTRY || "",
      COUNTRY_CODE: source_data?.current_country_code || "",
      BUSINESS_UNIT: source_data?.current_bussines_unit.value || "",
      MAPPING_TYPE: CURRENT_MMAPING_TYPE,
      USERID: user?.mail || "",
      PARTITIONED_BY: Partitioned_By_Value?.PARTITIONED_BY || "",
    };
    filteredDatasetValue = [NewRowData, ...CURRENT_MAPPED_DATA];

    let val = filteredDatasetValue;
    let ITEM_ID = 0;
    tableData =
      val &&
      val.map((item) => {
        let rowData;
        if (item.rowData) {
          rowData = {
            ...item,
            item_Id: ITEM_ID,
          };
        } else {
          rowData = {
            item_Id: ITEM_ID,
            isEditing: false,
            isNewData: true,
            isEdited: false,
            isPowerBrandNew: false,
            isRBFilteredBrandNew: false,
            isValidated: true,
            isCheckedRow: false,
            errorMessage: "",
            rowData: item,
          };
        }
        ITEM_ID++;
        return rowData;
      });

    //TABLE_DROPDOWN_DATA
    updateSourceInputs("any_row_isEditing", true);
    updateSourceInputs("current_mapped_data", tableData);
    updateSourceInputs("isNewDataInserted", true);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    setIsSearchFilterLoading(false);
    setIsEditDialogOpen(true);
    setCurrentEditingRowData(tableData[0]);
  };

  const handleSourceInput = (data, selectedRowsCount) => {
    updateSourceInputs("current_mapped_data", data);
    updateSourceInputs("checked_rows_count", selectedRowsCount);
  };

  const testRecords = (records) => {
    let MissingValues = {};
    const Current_Table_Data = records || [];

    const TABLE_HEAD_COLUMN_LIST =
      source_data?.data?.dropdown?.table_header_column_list || [];
    const EDIT_COLUMN_LIST =
      source_data?.data?.dropdown?.edit_model_column_list || [];
    const Mapping_Type_Field_Details =
      source_data?.data?.dropdown?.mapping_type_field_details || [];

    Current_Table_Data.forEach((item) => {
      TABLE_HEAD_COLUMN_LIST.forEach((column) => {
        // Skip if value is null
        if (
          !source_data?.data?.dropdown?.duplicate_validation_attributes?.includes(
            column.name,
          ) &&
          (item.rowData[column.name] === "null" ||
            item.rowData[column.name] === "" ||
            item.rowData[column.name] === null ||
            item.rowData[column.name]?.length === 0)
        ) {
          return true;
        }

        // Skip HARBOR_VALUE validation for mapped types
        if (
          column.name === "HARBOR_VALUE" &&
          Mapping_Type_Field_Details.includes(item.rowData.MAPPING_TYPE)
        ) {
          return; // skip to next column
        }

        // === DEPENDENT COLUMN CHECK ===
        if (column.is_dependent) {
          const Filtered_Dropdown_Data =
            source_data?.data?.dropdown?.[column.name] || [];
          const Parent_Column_Name = column.parent_column;
          const Parent_Column_Value = item.rowData?.[Parent_Column_Name];

          if (!Parent_Column_Name || !Parent_Column_Value) return;

          const Filtered_Final_Options = Filtered_Dropdown_Data.filter(
            (option) => option[Parent_Column_Name] === Parent_Column_Value,
          );

          if (!Filtered_Final_Options.length) return;

          const validOptions = Filtered_Final_Options[0][column.name] || [];
          const isValidated = validOptions.includes(item.rowData[column.name]);

          if (!isValidated) {
            MissingValues[column.name] = [
              ...(MissingValues[column.name] || []),
              item.rowData[column.name],
            ];
          }
          return;
        }

        // === NORMAL COLUMN VALIDATION ===
        const editableColumn = EDIT_COLUMN_LIST.find(
          (data) => data.name === column.name && data.type === "select",
        );

        if (editableColumn) {
          const IS_ARRAY = editableColumn.isArray;
          const DROPDOWN_DATA_NEW = source_data?.data?.dropdown || {};
          const Final_DropDown_Values = DROPDOWN_DATA_NEW[column.name] || [];

          let resultValid = false;

          if (IS_ARRAY) {
            if (Final_DropDown_Values.length === 0) {
              resultValid = true;
            } else {
              resultValid = Final_DropDown_Values.includes(
                item.rowData[column.name],
              );
            }
          } else {
            resultValid =
              column.name === "HARBOR_VALUE" &&
              Mapping_Type_Field_Details.includes(item.rowData.MAPPING_TYPE)
                ? true
                : Array.isArray(Final_DropDown_Values) &&
                  Final_DropDown_Values.includes(item.rowData[column.name]);
          }

          if (!resultValid) {
            MissingValues[column.name] = [
              ...(MissingValues[column.name] || []),
              item.rowData[column.name],
            ];
          }
        }
      });
    });

    return MissingValues;
  };

  function formatValidationErrorDetails(errorObj) {
    if (!errorObj || typeof errorObj !== "object") return "";

    return Object.entries(errorObj)
      .map(([key, values]) => {
        if (Array.isArray(values) && values.length > 0) {
          return `${key}: ${values.join(", ")}`;
        }
        return null;
      })
      .filter(Boolean)
      .join(" | ");
  }

  const handleValidateFileData = (tableData) => {
    updateAlert({
      open: true,
      message: "Validating row data's",
      severity: "success",
      closeFlag: true,
    });

    const Current_Table_Data = tableData;
    const TABLE_HEAD_COLUMN_LIST =
      source_data.data.dropdown.table_header_column_list;
    const EDIT_COLUMN_LIST = source_data.data.dropdown.edit_model_column_list;
    const Mapping_Type_Field_Details =
      source_data?.data?.dropdown?.mapping_type_field_details || [];

    // test
    const failedRecord = testRecords(Current_Table_Data);
    const errorDetails = formatValidationErrorDetails(failedRecord);

    const isValid = Current_Table_Data.every((item, indxxx) => {
      return TABLE_HEAD_COLUMN_LIST.every((column) => {
        if (
          !source_data?.data?.dropdown?.duplicate_validation_attributes?.includes(
            column.name,
          ) &&
          (item.rowData[column.name] === "null" ||
            item.rowData[column.name] === "" ||
            item.rowData[column.name] === null ||
            item.rowData[column.name]?.length === 0)
        ) {
          return true;
        }
        if (
          column.name === "HARBOR_VALUE" &&
          Mapping_Type_Field_Details &&
          Mapping_Type_Field_Details.length > 0 &&
          Mapping_Type_Field_Details?.includes(item.rowData.MAPPING_TYPE)
        ) {
          return true;
        }
        if (column.is_dependent) {
          const Filtered_Dropdown_Data = source_data.data.dropdown[column.name];
          const Parent_Column_Name = column.parent_column;
          const Parent_Column_Value = item.rowData[Parent_Column_Name];

          // CHECK IS VALID VALUE
          const Filtered_Final_Options =
            Parent_Column_Value !== null
              ? Filtered_Dropdown_Data.filter(
                  (option) =>
                    option[Parent_Column_Name] === Parent_Column_Value,
                )
              : [];

          const isValidated = Filtered_Final_Options[0][column.name].includes(
            item.rowData[column.name],
          );

          return isValidated;
        } else {
          let IS_ARRAY;
          let result = EDIT_COLUMN_LIST.find((data) => {
            if (column.name === data.name) {
              if (data.isArray) {
                IS_ARRAY = true;
              }
              return data.type === "select";
            }
            return false;
          });

          if (result && result.type === "select") {
            const DROPDOWN_DATA_NEW = source_data.data.dropdown;
            const Final_DropDown_Values =
              DROPDOWN_DATA_NEW?.[column.name] || [];

            // UNCOMMENT IF CASE SENSITIVE TEST IS NOT REQUIRED
            // const isValidated = Array.isArray(Final_DropDown_Values) && Final_DropDown_Values.some((option)=> option.toUpperCase() === item.rowData[column.name].toUpperCase() )

            let resultvalid;
            if (IS_ARRAY && Array.isArray(Final_DropDown_Values)) {
              if (Final_DropDown_Values.length === 0) {
                resultvalid = true;
              } else {
                const column_value = item.rowData[column.name];
                const value_result =
                  Final_DropDown_Values.includes(column_value);
                resultvalid = value_result;
              }
            } else {
              resultvalid =
                column.name === "HARBOR_VALUE" &&
                Mapping_Type_Field_Details.includes(item.rowData.MAPPING_TYPE)
                  ? true
                  : Array.isArray(Final_DropDown_Values) &&
                    Final_DropDown_Values.includes(item.rowData[column.name]);
            }

            return resultvalid;
          } else {
            return true;
          }
        }
      });
    });

    if (isValid) {
      updateAlert({
        open: true,
        message: "File data validated successfully",
        severity: "success",
        closeFlag: true,
      });
      updateSourceInputs("is_table_loading", false);
      setIsFileUploading(false);

      const MODIFIED_MAPPED_DATA = Current_Table_Data.map((item) => {
        return {
          actual: {},
          isNew: false,
          isEdited: true,
          updated: { ...(item?.rowData || {}) },
        };
      });

      updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);
      updateSourceInputs("current_mapped_data", tableData);
      updateSourceInputs("isFileUploaded", true);
    } else {
      updateSourceInputs("is_initial", true);
      updateAlert({
        open: true,
        message: `Validation Failed! Invalid column value found in these columns ---> ${errorDetails}`,
        severity: "success",
        closeFlag: true,
      });
    }

    setIsFileUploading(false);
  };

  const handleFileUpload = (records) => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", true);
    setIsFileUploading(true);

    const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const Existing_Records = source_data.current_mapped_data;
    const XL_FILE_RECORDS = records.map((item) => {
      return {
        ...item,
        CREATED_AT: item.CREATED_AT || null,
        CREATED_BY: item.CREATED_BY || null,
        UPDATED_AT: item.UPDATED_AT || null,
        UPDATED_BY: item.UPDATED_BY || null,
      };
    });

    const FILTEREDRECORDS = XL_FILE_RECORDS.map((item, i) => {
      const existing_Data = Existing_Records?.[i];
      return { ...(existing_Data?.rowData || {}), ...item };
    });

    let ITEM_ID = 0;
    const tableData =
      FILTEREDRECORDS &&
      FILTEREDRECORDS.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    handleValidateFileData(tableData);
  };

  const handleDialogClose = () => {
    if (!isTableDataSaving) {
      setIsSaveDialogOpen(false);
    }
  };

  const handleDialogOpen = () => {
    setIsSaveDialogOpen(true);
  };

  const handleDynamicDialogClose = () => {
    setIsDynamicDialogOpen(false);
  };

  const handleDynamicDialogCancel = () => {
    handleDynamicDialogClose();
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
  };

  // CONSTANTS
  const SOURCE_DATASET_LIST =
    source_data?.current_mapped_source &&
    source_data?.current_mapped_source.map((data) => {
      return data.toString();
    });

  const SOURCE_DATA_SET_SELECTED =
    SOURCE_DATASET_LIST &&
    SOURCE_DATASET_LIST.map((data) => {
      return { label: data, value: data };
    });

  // USE EFFECTS
  useEffect(() => {
    if (
      source_data.current_category != "" &&
      source_data.current_source != ""
    ) {
      setPage(0);
    }
  }, [source_data.current_source, source_data.current_category]);

  return (
    <>
      <>
        {loading ? (
          <Loader />
        ) : isApproval ? (
          <ApprovalTable
            sourceData={source_data}
            user={user}
            login={login}
            updateAlert={updateAlert}
            getApprovalData={getApprovalData}
            usecase_name={Use_Case_Name}
          />
        ) : (
          <MetaSearchFilter
            loading={loading}
            setLoading={setLoading}
            setMappedData={setMappedData}
            isSearchFilterLoading={isSearchFilterLoading}
            handleFileUpload={handleFileUpload}
            isFileUploading={isFileUploading}
            isPlaceholderFetching={isPlaceholderFetching}
          />
        )}

        {/* Loader new code */}
        {!source_data.is_initial ? (
          !source_data.is_table_loading ? (
            <>
              <EditableTable
                initWithoutHead
                page_props={page_props}
                sourceDropdownData={source_data.data.dropdown}
                defaultData={source_data.current_mapped_data}
                checkedRowCount={source_data.checked_rows_count}
                getData={getData}
                handleFileUpload={handleFileUpload}
                isFileUploading={isFileUploading}
                fieldsArr={fieldsArr}
                rowsPerPage={rowsPerPage}
                setIsEdit={setIsEdit}
                setGlobalEdit={setGlobalEdit}
                page={page}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
                updateSourceHandler={handleSourceInput}
                sourceDatasetSelected={SOURCE_DATA_SET_SELECTED}
                setIsSearchFilterLoading={setIsSearchFilterLoading}
                isEditDialogOpen={isEditDialogOpen}
                setIsEditDialogOpen={setIsEditDialogOpen}
                currentEditingRowData={currentEditingRowData}
                setCurrentEditingRowData={setCurrentEditingRowData}
                outlinedCNCButton={outlinedCNCButton}
                containedButton={containedButton}
              />

              {/* Action button and disclaimer */}
              <div>
                <div className="disclaimer">
                  {/* INSERT NEW BUTTON */}
                  {/* {!source_data.current_mapped_data_main.length > 0 && ( */}
                  <div>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={handleCreateNewRow}
                      disabled={isSearchFilterLoading || IS_ANY_ROWDATA_NULL}
                    >
                      <span>Insert new</span>
                    </Button>
                  </div>
                  {/* )} */}

                  {/* DISCLAIMER */}
                  <div>
                    {source_data?.data?.dropdown?.disclaimer_details
                      ?.is_Disclaimer_available &&
                      Array.isArray(
                        source_data?.data?.dropdown?.disclaimer_details
                          ?.disclaimer_text,
                      ) &&
                      source_data.data.dropdown.disclaimer_details
                        .disclaimer_text.length > 0 && (
                        <div style={{ display: "flex" }}>
                          <p
                            style={{
                              margin: "0px",
                            }}
                          >
                            Disclaimer:
                          </p>
                          <ul
                            style={{
                              listStyle:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "outside"
                                  : "none",
                              margin: "0px",
                              marginLeft:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "0px"
                                  : "-15px",
                            }}
                          >
                            {source_data.data.dropdown.disclaimer_details.disclaimer_text.map(
                              (text, idx) => (
                                <li key={idx}>{text}</li>
                              ),
                            )}
                          </ul>
                        </div>
                      )}
                  </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="action-buttons">
                  <div className="">
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(true)}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>

                    {IS_ANY_RECORDS_EDITED && (
                      <Button
                        disableFocusRipple
                        style={containedButton}
                        onClick={handleDialogOpen}
                        disabled={isTableDataSaving}
                      >
                        <span>Save</span>
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              {/* SAVE DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isSaveDialogOpen}
                  onClose={handleDialogClose}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be created as a new version. Do
                        you want to continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={handleDialogClose}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      disabled={isTableDataSaving}
                      onClick={
                        source_data.has_awaiting_data.has_records
                          ? onSaveAwaitingData
                          : onSave
                      }
                    >
                      Continue
                      {isTableDataSaving && <Loader />}
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              {/* CANCEL DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isCancelDialogOpen}
                  onClose={() => setIsCancelDialogOpen(false)}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be undone. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={cancelFunction}
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </>
          ) : (
            <Loader />
          )
        ) : (
          <div style={{ textAlign: "center" }}>
            {/* Choose the above mapping filters */}
          </div>
        )}

        {
          <DynamicDialog
            openModal={isDynamicDialogOpen}
            closeModel={handleDynamicDialogClose}
            title={"Confirmation"}
            hasCustomCancelButton={true}
            content={
              <p style={{ fontSize: "16px", color: "black", marginTop: "6px" }}>
                {dynamicDialogMessage}
              </p>
            }
            actions={
              <>
                <Button
                  onClick={handleDynamicDialogCancel}
                  style={{
                    fontFamily: "Hind Siliguri",
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {source_data.has_awaiting_data.has_access ? "Cancel" : "Ok"}
                </Button>
                {source_data.has_awaiting_data.has_access && (
                  <Button
                    onClick={fetchAwaitingRecords}
                    style={{
                      backgroundColor: "#46596A",
                      fontFamily: "Hind Siliguri",
                      fontSize: "12px",
                      fontWeight: "bold",
                      marginRight: "5px",
                      color: "white",
                    }}
                  >
                    fetch
                  </Button>
                )}
              </>
            }
          />
        }
      </>
    </>
  );
}

PillerPowerBrandView.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  brand_data: PropTypes.object,
  cncData: PropTypes.object,
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  // userData:state.cncStateData.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PillerPowerBrandView),
);
